"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function getIsTabFieldsDisabled() {
    return (state, actions, { tabName = state.ui.currentTabName } = {}) => () => {
        return state.tabs[tabName].imageVisibilityState !== 'showImage';
    };
}
exports.getIsTabFieldsDisabled = getIsTabFieldsDisabled;
//# sourceMappingURL=get-is-tab-fields-disabled.js.map